import { toPersianDigits } from "./persianDigits";

const PERSIAN_ARABIC_BLOCK = /[؀-ۿ]/;
const LATIN_LETTER = /[a-zA-Z]/;

// Script-sniffs a string and returns the HTML `dir` it should render with:
// "ltr" for Latin-script text with no Persian/Arabic letters in it, "rtl"
// for everything else (Persian text, mixed text, or empty/missing text —
// the site's default). Same rule RichText.js's persianizeDigitsInHtml and
// HeroPosterCard's isLatinTitle already use for script detection, pulled
// out so card components can apply it as a real dir attribute instead of
// just a word-break CSS hint.
export function detectTextDirection(value) {
  const text = Array.isArray(value) ? value.join(" ") : value;
  if (!text) return "rtl";
  return LATIN_LETTER.test(text) && !PERSIAN_ARABIC_BLOCK.test(text) ? "ltr" : "rtl";
}

// A Western-digit date/number sitting inside an otherwise-Persian string
// ("پیوریسم (1918)") should read in Persian numerals like the rest of it;
// the same digits inside an English string stay Western. Only ever
// localizes toward Persian — "ltr" text is returned exactly as given.
export function localizeDigits(text, dir) {
  if (text === null || text === undefined) return text;
  return dir === "rtl" ? toPersianDigits(text) : text;
}

// Combines both: detects a title/line's script and returns the dir to
// render it with plus its text with digits localized to match. Used for
// every page title (card or content-page <h1>) whose source text is
// plain, admin-authored text rather than RichText HTML.
export function localizeTitle(value) {
  const dir = detectTextDirection(value);
  const text = Array.isArray(value) ? value.map((line) => localizeDigits(line, dir)) : localizeDigits(value, dir);
  return { dir, text };
}
